import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/expense/deleteaction";
import updateaction from "../../context/action/expense/updateaction";
const Editexpensemodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);

  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-2/3 max-w-6xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="grid grid-cols-1 gap-4 w-full">
                    <div className="w-full">
                      <label
                        className={
                          error
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="expense_amount"
                      >
                        بڕی خەرجی
                      </label>
                      <input
                        className={
                          error
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="expense_amount"
                        type="number"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props.expense_amount}
                        onChange={(val) =>
                          props.setexpense_amount(val.target.value)
                        }
                        onFocus={() => seterror(false)}
                      />
                    </div>
                    <div className="w-full">
                      <label
                        for="cate"
                        className={
                          error1
                            ? "block mb-2 text-sm font-medium text-red-500"
                            : "block mb-2 text-sm font-medium text-gray-900"
                        }
                      >
                        جۆری خەرجی
                      </label>
                      <select
                        id="cate"
                        className={
                          error1
                            ? "bg-gray-50 border border-red-500 text-red-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 h-12"
                            : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 h-12"
                        }
                        value={props.expense_type_id}
                        onChange={(val) => {
                          seterror1(false);
                          props.setexpense_type_id(val.target.value);
                        }}
                      >
                        <option value="null">جۆری خەرجی هەڵبژێرە</option>
                        {initState.active_expense_type.map((lis) => (
                          <option value={lis.expense_type_id}>
                            {lis.expense_type_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <label
                        className={
                          "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="note"
                      >
                        تێبینی
                      </label>
                      <input
                        className={
                          "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="note"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props.expense_note}
                        onChange={(val) =>
                          props.setexpense_note(val.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                    type="button"
                    onClick={() => {
                      if (
                        window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                      ) {
                        deleteaction(props.expense_id)(recaller)(setrecaller)(
                          initDispatch
                        )(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                    type="button"
                    onClick={() => {
                      if (
                        props.expense_type_id == "null" ||
                        !props.expense_type_id
                      ) {
                        seterror1(true);
                        return false;
                      }
                      if (!props.expense_amount) {
                        seterror(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.expense_id,
                          props.expense_amount,
                          props.expense_type_id,
                          props.expense_note,
                          initState.token.user_id
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Editexpensemodal;
